import React from "react";
import OptOutForm from "../../components/OptOutForm";

export default function LimitSensitive() {
  return (
    <OptOutForm
      variant="limit-sensitive"
      testid="legal-limit-sensitive"
      eyebrow="California Civ. Code §1798.121 · CPRA Reg. §7027"
      title="Limit the Use of My Sensitive Personal Information"
      intro="California residents can ask BlueRoam to limit the use of sensitive personal information (e.g. government-ID images, account credentials) to the purposes permitted by CPRA Reg. §7027 — necessary to perform the services or for security, fraud prevention and compliance."
      successLine="We will limit the use of your sensitive personal information to the legally permitted purposes only — no inference of characteristics, no marketing personalisation, no disclosure to advertising partners."
    />
  );
}
